import React from "react";
import CommonTable from "components/CommonTable";
import { l } from "helpers/log";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Spinner } from "react-bootstrap";
import { TbEditCircle } from "react-icons/tb";
import { TiDocumentDelete } from "react-icons/ti";
import { getDistributes, deleteDistribute } from "network/apis/DistributeApi";
import useModal from "hooks/useModal";
import DeleteInputPrompt from "components/DeleteInputPrompt";
import { getPersianFormattedDate } from "helpers/dates";
import { getErrorMessage } from 'helpers/strings';
import HoverText from 'components/HoverText';
import { useCompanySelector, useCompanyDispatch } from 'company-app/redux/company.store';
import { buildFiltersQuery, goToPage } from 'company-app/redux/filter.slice';

const Holder = styled.div`
  width: 100%;

  div.loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3876e5;
    min-height: 30rem;
  }
`;

const DistributeTab = ({ parentType, distsData, isLoading, refetch, onEditTap }) => {
  const queryClient = useQueryClient();

  const filterState = useCompanySelector((store) => store.filter);
  const dispatch = useCompanyDispatch();

  const {
    isOpen: isDeleteModalOpen,
    handleOpenModal: handleOpenDeleteModal,
    handleCloseModal: handleCloseDeleteModel,
    data: deleteModalData,
  } = useModal();

  const deleteDistMutation = useMutation(deleteDistribute, {
    onSuccess: (res) => {
      if (res && res.status === 204) {
        toast(`با موفقیت حذف گردید`, {
          type: "success",
          position: "bottom-right",
        });

        refetch();
        queryClient.invalidateQueries(['get-dist-statistics']);
      }
    },
    onError: (err) => {
      toast(getErrorMessage(err), {
        type: "error",
        position: "bottom-right",
      });
    },
  });

  const cols = [
    "حذف",
    "ویرایش",
    "توضیحات",
    "تاریخ ثبت",
    "تاریخ توزیع",
    "دریافت کننده",
    "واحد",
    "مقدار",
    parentType === 'admin' ? 'مبلغ (ریال)' : "نام عشایر",
    "نوع نهاده",
    "ردیف",
  ];

  return (
    <Holder>
      {isLoading ? (
        <div className="loading">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <CommonTable
          cols={cols}
          pageCount={parseInt(distsData?.data?.num_pages ?? 1)}
          pageOffset={filterState.pageOffset - 1}
          fetchPageAt={(pageOffset) => {
            dispatch(goToPage(pageOffset));
            dispatch(buildFiltersQuery());
          }}
        >
          {distsData?.data?.items?.map((dist, index) => (
            <tr key={`${dist?.pur_id}-${dist?.created_at}`}>
              <td>
                <TiDocumentDelete
                  onClick={() => {
                    handleOpenDeleteModal(dist);
                  }}
                />
              </td>
              <td>
                <TbEditCircle onClick={() => {
                  onEditTap?.(dist);
                }} />
              </td>
              <td>
                <HoverText>{dist?.description ?? '-'}</HoverText>
              </td>
              <td>{getPersianFormattedDate(dist?.created_at)}</td>
              <td>{getPersianFormattedDate(dist?.date)}</td>
              <td>{dist?.destination?.name || dist?.nomad_national_code || '-'}</td>
              <td>{dist?.unit?.name}</td>
              <td>{`${dist?.amount ?? 0}`.persianCurrency()}</td>
              <td>{parentType === 'admin' ? `${dist?.cost ?? 0}`.persianCurrency() : dist?.nomad_name}</td>
              <td>{dist?.input?.name}</td>
              <td>{index + 1}</td>
            </tr>
          ))}
        </CommonTable>
      )}
      {isDeleteModalOpen && (
        <DeleteInputPrompt
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModel}
          onActionTap={(warehouseSelected) => {
            handleCloseDeleteModel();
            deleteDistMutation.mutate({ id: deleteModalData?.dist_id, warehouseSelected: false });
          }}
        />
      )}
    </Holder>
  );
};

export default DistributeTab;
